export const ApiMethodType = {
    CreateBusinessCase: 0,
    UpdateBusinessCase: 1,
    CloneBusinessCase: 2,
    Calculate: 3,
    ImportCalculation: 4,
    UpdateCalculation: 5,
    CloneCalculation: 6,
    ConfirmCalculation: 7,
    CreatePolicy: 8,
    Activate: 9,
    UpdatePolicy: 10,
    CancelPolicy: 11,
    GetDocuments: 12,
    GetPdf: 13,
    GetBusinessCase: 14,
    EndClientInsurance: 15,
    EndStockInsurance: 16,
    CreateStock: 17,
    Reactivate: 18,
    GetIndexedContracts: 19,
    PaymentProfile: 20,
}

export type ApiMethodType = typeof ApiMethodType[keyof typeof ApiMethodType]

export const ApiMethodTypes: [ApiMethodType, string][] = [
    [ApiMethodType.CreateBusinessCase, 'Vytvoření obch. případu'],
    [ApiMethodType.UpdateBusinessCase, 'Aktualizace obch. případu'],
    [ApiMethodType.GetBusinessCase, 'Získání obch. případu'],
    [ApiMethodType.CloneBusinessCase, 'Klonování obch. případu'],
    [ApiMethodType.Calculate, 'Kalkulace nabídek'],
    [ApiMethodType.ImportCalculation, 'Import nabídky (FLAT)'],
    [ApiMethodType.UpdateCalculation, 'Re-kalkulace nabídky'],
    [ApiMethodType.CloneCalculation, 'Klonování nabídky'],
    [ApiMethodType.ConfirmCalculation, 'Potvrzení kalkulace'],
    [ApiMethodType.CreatePolicy, 'Sjednání smlouvy'],
    [ApiMethodType.Activate, 'Aktivace smlouvy'],
    [ApiMethodType.UpdatePolicy, 'Změny smlouvy'],
    [ApiMethodType.CancelPolicy, 'Storno smlouvy'],
    [ApiMethodType.GetDocuments, 'Vyžádání dokumentů'],
    [ApiMethodType.GetPdf, 'Získání pdf nabídek'],
    [ApiMethodType.EndClientInsurance, 'Storno klientského pojištění'],
    [ApiMethodType.EndStockInsurance, 'Storno skladového pojištění'],
    [ApiMethodType.CreateStock, 'Založení skladového pojištění'],
    [ApiMethodType.Reactivate, 'Reaktivace'],
    [ApiMethodType.GetIndexedContracts, 'Stáhnutí indexovaných smluv'],
    [ApiMethodType.PaymentProfile, 'Změna platebního profilu'],
]